import axios from "axios";
import { DEFAULT_GROUP_TREASURY } from "@/preferences/types";
const BASE_URL = "https://front.microcentrum.cl/v1/cursos";
const getAuthHeaders = () => {
    const authToken = localStorage.getItem("authToken");
    if (!authToken) {
        throw new Error("No se encontró token de autenticación");
    }
    return {
        Accept: "application/json",
        Authorization: authToken,
    };
};
export const cursoRefFromGuardian = (curso) => {
    if (!curso)
        return null;
    const school_id = String(curso.school_id || "").trim();
    const year = String(curso.year ?? "").trim();
    const course_code = String(curso.course_code || curso.course_id || "").trim();
    if (!school_id || !year || !course_code)
        return null;
    return { school_id, year, course_code };
};
export const toLocalGroupSettings = (groupKey, remote) => ({
    groupKey,
    modules: remote.modules ?? {},
    treasury: {
        enabled: remote.treasury?.enabled ?? DEFAULT_GROUP_TREASURY.enabled,
        bankStatements: remote.treasury?.bankStatements ?? DEFAULT_GROUP_TREASURY.bankStatements,
    },
});
export const hasLocalGroupCustomizations = (settings) => {
    if (Object.keys(settings.modules || {}).length > 0)
        return true;
    if (settings.treasury?.enabled === false)
        return true;
    if (settings.treasury?.bankStatements === false)
        return true;
    return false;
};
export const fetchGroupModuleSettings = async (curso) => {
    const ref = cursoRefFromGuardian(curso);
    if (!ref) {
        throw new Error("Faltan school_id, year o course_code");
    }
    const response = await axios.get(BASE_URL, {
        params: { op: "groupModuleSettings", ...ref },
        headers: getAuthHeaders(),
    });
    return response.data;
};
export const saveGroupModuleSettingsRemote = async (curso, settings) => {
    const ref = cursoRefFromGuardian(curso);
    if (!ref) {
        throw new Error("Faltan school_id, year o course_code");
    }
    const response = await axios.post(BASE_URL, {
        ...ref,
        modules: settings.modules,
        treasury: settings.treasury,
    }, {
        params: { op: "groupModuleSettings" },
        headers: getAuthHeaders(),
    });
    return response.data;
};
